import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'react-router';
import styles from './BlogPostItem.css';

class BlogPostItem extends Component {
  static propTypes = {
    post: PropTypes.object.isRequired,
  };

  render() {
    const { post } = this.props;

    return (
      <div className="col--m-4of12">
        <Link to={`/journal/${post.title}`} className={styles.blogPostItem}>
          <div className={styles.listImg}>
            {post.listImg && (
              <div className={styles.content} style={{ backgroundImage: `url(${post.listImg.url}?w=972&fm=jpg&fl=progressive)` }} />
            )}
            {!post.listImg && (
              <div className={classnames(styles.content, styles.placeholder)} />
            )}
          </div>
          <p className={styles.postTitle}>{post.title}</p>
          <p className={styles.postExtract}>{post.extract}</p>
        </Link>
      </div>
    );
  }
}

export default BlogPostItem;



// WEBPACK FOOTER //
// ./src/components/blog-post-item/BlogPostItem.js